import { DollarSign, TrendingUp, Calculator, Users, Target, PiggyBank, Percent, Briefcase } from 'lucide-react'

// Labels mapping for financial metrics
export const labels: Record<string, string> = {
  faturamento: 'Faturamento',
  receita: 'Receita Bruta',
  impostos: 'Impostos',
  folha: 'Folha',
  despesas: 'Despesas',
  receitaFinanceira: 'Receita Financeira',
  lucroLiquido: 'Lucro Líquido',
  custosServicoPrestado: 'Custos de Serviço Prestado'
}

// Icons mapping for financial metrics
export const icons: Record<string, any> = {
  faturamento: DollarSign,
  receita: TrendingUp,
  impostos: Calculator,
  folha: Users,
  despesas: Target,
  receitaFinanceira: PiggyBank,
  lucroLiquido: TrendingUp,
  custosServicoPrestado: Briefcase
}

// Configuration for chart lines
export const metricsConfig = {
  faturamento: { color: '#3B82F6', name: 'Faturamento' },
  receita: { color: '#10B981', name: 'Receita Bruta' },
  impostos: { color: '#EF4444', name: 'Impostos' },
  folha: { color: '#F59E0B', name: 'Folha' },
  despesas: { color: '#DC2626', name: 'Despesas' },
  receitaFinanceira: { color: '#8B5CF6', name: 'Receita Financeira' },
  lucroLiquido: { color: '#059669', name: 'Lucro Líquido' },
  custosServicoPrestado: { color: '#F97316', name: 'Custos de Serviço Prestado' }
}

// Financial data type interface
export interface FinancialData {
  real: number
  proa: number
  variance: number
  previousValue?: number // Value from previous period for comparison
}